export default __webpack_public_path__ + "static/media/tom_sachs.2bf89a74.svg";